import { isFunction } from './function.js';
import { isObject } from './object.js';
export function isOn() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return value => (isObject(value) || isFunction(value)) && fns.every(f => isFunction(value[f]));
}
export function isOnFunction() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return value => isFunction(value) && fns.every(f => isFunction(value[f]));
}
export function isOnObject() {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }
  return value => isObject(value) && fns.every(f => isFunction(value[f]));
}